import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { AuthModule } from '../security/authorization/auth.module';
import { CommonModule } from '@angular/common';
import { FormsModule } from '../forms/forms.module';
import { VerificationComponent } from './components/verification.component';

@NgModule({
    imports: [
        AuthModule,
        CommonModule,
        FormsModule,
        NgbTooltipModule,
        ReactiveFormsModule,
    ],
    declarations: [VerificationComponent],
    exports: [VerificationComponent],
})
export class VerificationModule {}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/components/verification/verification.module.ts